var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stock-market (7) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.872 9.06735C30.8579 9.65385 30.3719 10.1185 29.7854 10.1058C29.1989 10.0916 28.7343 9.60568 28.747 9.01918L28.8051 6.46068L26.248 6.4026C25.6615 6.38843 25.1969 5.90252 25.2096 5.31602C25.2238 4.72952 25.7097 4.26485 26.2962 4.2776L29.9172 4.36118C30.5037 4.37393 30.9684 4.85985 30.9542 5.44635L30.872 9.06735Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25496 13.2404V30.4402C8.25496 31.429 7.45454 32.2294 6.46571 32.2294H3.56012C2.57129 32.2294 1.77087 31.429 1.77087 30.4402V13.2404C1.77087 12.253 2.57129 11.4512 3.56012 11.4512H6.46571C7.45454 11.4512 8.25496 12.253 8.25496 13.2404Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2377 21.9592V30.4408C24.2377 30.9153 24.0493 31.3701 23.7136 31.7058C23.3778 32.0416 22.9231 32.23 22.4485 32.23H19.5429C19.0683 32.23 18.6136 32.0416 18.2778 31.7058C17.9421 31.3701 17.7537 30.9153 17.7537 30.4408V21.9592C17.7537 21.4846 17.9421 21.0298 18.2778 20.6941C18.6136 20.3583 19.0683 20.1699 19.5429 20.1699H22.4485C22.9231 20.1699 23.3778 20.3583 23.7136 20.6941C24.0493 21.0298 24.2377 21.4846 24.2377 21.9592Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2464 17.5998V30.4405C16.2464 31.4293 15.446 32.2297 14.4572 32.2297H11.5516C10.5627 32.2297 9.76233 31.4293 9.76233 30.4405V17.5998C9.76233 17.1252 9.95075 16.6705 10.2865 16.3347C10.6222 15.999 11.077 15.8105 11.5516 15.8105H14.4572C15.446 15.8105 16.2464 16.6124 16.2464 17.5998Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2292 17.5998V30.4405C32.2292 31.4293 31.4288 32.2297 30.4399 32.2297H27.5344C26.5455 32.2297 25.7451 31.4293 25.7451 30.4405V17.5998C25.7451 17.1252 25.9335 16.6705 26.2693 16.3347C26.605 15.999 27.0598 15.8105 27.5344 15.8105H30.4399C31.4288 15.8105 32.2292 16.6124 32.2292 17.5998Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4709 3.68357C3.00057 3.33224 2.90565 2.66499 3.2584 2.19607C3.60973 1.72715 4.27557 1.63224 4.7459 1.98357L13.1793 8.30899H17.1842C17.5115 8.30899 17.8189 8.45915 18.0201 8.71557L21.26 12.8395L28.7683 5.0039C29.1735 4.58032 29.8464 4.56615 30.27 4.97274C30.6936 5.3779 30.7077 6.05082 30.3026 6.4744L21.9471 15.1926C21.7346 15.415 21.4356 15.534 21.1282 15.5184C20.8208 15.5042 20.5347 15.3555 20.3448 15.1132L16.6686 10.434H12.8252C12.5957 10.434 12.3718 10.3603 12.1876 10.2215L3.4709 3.68357Z",
    fill: "#00FFF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg101);
export default __webpack_public_path__ + "static/media/svg1-01.9f5b4648d4a7252514de06278052c8dc.svg";
export { ForwardRef as ReactComponent };